import { render, staticRenderFns } from "./BillingCarrierRelatedInfoBadge.vue?vue&type=template&id=071ec9a6"
import script from "./BillingCarrierRelatedInfoBadge.vue?vue&type=script&lang=js"
export * from "./BillingCarrierRelatedInfoBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports